@if (game.isGamePending()) {
  <section
    (click)="openDialogResumeGame()"
    (keyup)="openDialogResumeGame()"
    tabindex="-1"
    >
    <div class="title text-center ">
      {{ 'components.currentAction.currentPlay' | transloco }}
      <span class="play-number">{{ currentGamePlay.gamePlayNumber }}</span>
    </div>
    <code>{{ currentGamePlay.down }}</code>
    <div class="texte">{{ 'components.currentAction.down' | transloco }}</div>
    <code>{{ currentGamePlay.distance }}</code>
    <div class="texte">{{ 'components.currentAction.distance' | transloco }}</div>
    <code>{{ currentGamePlay.yardLine }}</code>
    <div class="texte">{{ 'components.currentAction.yardLine' | transloco }}</div>
    <mat-icon
      title="{{ 'components.topSection.resume' | transloco }}"
    data-testid="resume">edit</mat-icon>
  </section>
}
